<template>
  <GroupSingle
    :group="group"
  />
</template>

<script>
import GroupSingle from '../components/GroupSingle'

export default {
  name: 'CustomerSinglePage',

  components: {
    GroupSingle
  },

  async beforeRouteLeave (to, from, next) {
    if (this.group && this.group.isChanged) {
      const answer = await this.$root.$confirm(this.$t('Attention'), this.$t('You have unsaved changes. Are you sure want to leave?'), { color: 'primary' })
      if (answer) {
        this.group.reset()
      }
      return next(answer)
    }
    next()
  },

  actionBar () {
    return {
      title: 'Customer Group',
      actions: [
        {
          text: 'Save',
          event: 'save',
          disabled: true
        },
        {
          color: 'error',
          text: 'Delete',
          event: 'delete',
          disabled: true
        }
      ]
    }
  },

  data () {
    return {
      group: this.$http.make('customer:group')
    }
  },

  computed: {
    saveActionStates () {
      return {
        disabled: !this.group || this.group.inProgress || !this.group.isDirty() || this.group.errors.length,
        loading: !this.group || this.group.inProgress
      }
    },

    deleteActionStates () {
      return {
        disabled: !this.group || this.group.inProgress
      }
    }
  },

  async mounted () {
    try {
      this.group = await this.$http.make('customer:group').find(this.$route.params.id)

      this.$radio.$emit('action-panel-title', this.group.name)
    } catch (e) {
      this.$toast.error(this.$t(e.message))
    }

    this.$radio.$on('requested-customer-save', this.onActionSave)
  },

  methods: {
    goBack () {
      this.$router.push({ name: 'groups' })
    },

    onActionSave () {
      this.group.customer_ids = this.group.customers.map(item => item.id)

      this.group.save()
        .catch(e => {
          this.$vuetify.goTo(0)
          this.$toast.error(this.$t(e.message))
        })
    },

    async onActionDelete () {
      if (!await this.$root.$confirm(this.$t('Danger Zone'), this.$t('Please Confirm'), { color: 'red' })) {
        return
      }
      await this.group.delete()
      this.goBack()
    }
  }
}
</script>
